import React from 'react';

interface BANProps {
  value: string | number;
  label: string;
  loading?: boolean;
}

export const BAN: React.FC<BANProps> = ({ value, label, loading = false }) => {
  return (
    <div className="ban-container">
      <div className="ban-value">
        {loading ? '...' : value}
      </div>
      <div className="ban-label">{label}</div>
    </div>
  );
};

